export const postMailingCampaignsKeys = {
	all: ['postMailingCampaigns'],
	list: () => ['postMailingCampaigns', 'list'],
	detail: (id) => ['postMailingCampaigns', 'detail', id],
	sends: (id, filters, page, pageSize) => ['postMailingCampaigns', 'sends', id, filters, page, pageSize],
	// Prefix key for invalidating every paginated/filtered sends variant of a campaign at once.
	sendsByCampaign: (id) => ['postMailingCampaigns', 'sends', id],
	sendsStats: (id) => ['postMailingCampaigns', 'sendsStats', id],
	blockedRecipients: (id) => ['postMailingCampaigns', 'blockedRecipients', id],
	costEstimate: (id) => ['postMailingCampaigns', 'costEstimate', id],
};

export const postMailingCampaignsMutationKeys = {
	create: ['postMailingCampaigns', 'create'],
	update: ['postMailingCampaigns', 'update'],
	delete: ['postMailingCampaigns', 'delete'],
	syncLists: ['postMailingCampaigns', 'syncLists'],
	confirmAndSend: ['postMailingCampaigns', 'confirmAndSend'],
	abandonPayment: ['postMailingCampaigns', 'abandonPayment'],
	resumePayment: ['postMailingCampaigns', 'resumePayment'],
	confirmWarnings: ['postMailingCampaigns', 'confirmWarnings'],
	cancel: ['postMailingCampaigns', 'cancel'],
	refreshStatus: ['postMailingCampaigns', 'refreshStatus'],
	downloadSendPdf: ['postMailingCampaigns', 'downloadSendPdf'],
	exportCsv: ['postMailingCampaigns', 'exportCsv'],
};
